import Api from '@/services/Api'

export default {
  processPayment (paymentData) {
    return Api().post('payment/process', paymentData)
  },
  saveOrder (order) {
    return Api().post('payment/success', order)
  }
}



// WEBPACK FOOTER //
// ./src/services/PaymentService.js